import React from "react";

export function AdditionalOfferCount(props: { count: number }) {
	if (props.count == null) {
		return <td className="match__counter" />;
	}

	if (props.count <= 0) {
		return (
			<div className="match__counter">
				<div className="match__counter__number">
					<i className="match__counter__icon u-icon u-icon--xtny u-icon--caret--right" />
				</div>
			</div>
		);
	}

	return (
		<div className="match__counter">
			<div className="match__counter__number">
				<span>+{props.count}</span>
				<i className="match__counter__icon u-icon u-icon--xtny u-icon--caret--right" />
			</div>
		</div>
	);
}
